import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import { ArrowForward } from '@mui/icons-material';
import RightImagePage from '../layouts/RightImagePage';

import signupImage from '../../assets/signup.jpg';
import { PARTNER } from '../../lib/signup-policy';

// Where /signup lands while registration is closed, and where a Google/GitHub
// popup that turns out to belong to a new person gets redirected (see
// api/user.js). Deliberately not styled as an error: whoever reaches this page
// wanted the service, so explain what changed before sending them on.
export default function SignupClosed() {
  return (<RightImagePage image={signupImage} component="main"
    sx={{
      my: 'auto',
      py: 2,
      pb: 5,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      width: 400,
      maxWidth: '100%',
      mx: 'auto',
      borderRadius: 'sm',
    }}>
    <div>
      <Typography component="h1" fontSize="xl2" fontWeight="lg">
        A note about Aplisay Playground
      </Typography>
      <Typography level="body2" sx={{ my: 1, mb: 3 }}>
        The free self-service playground has closed
      </Typography>
    </div>

    <Typography level="body2">
      Thank you for looking for it. We loved offering a zero-setup way to try
      llm-agent and the Aplisay APIs, but keeping a public free playground
      healthy, secure and reliable is no longer something we can sustainably
      offer.
    </Typography>

    <Typography level="body2">
      Hosted service work has moved into {PARTNER.name}: a paid beta for
      building AI voice agents that answer real phone numbers. It keeps the same
      spirit &mdash; plain-English setup, an open-source core, and practical
      tools for teams who want calls answered well.
    </Typography>

    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 'sm', p: 2 }}>
      <Typography fontWeight="lg">
        Approved organisations start gently
      </Typography>
      <Typography level="body2" sx={{ mt: 0.5 }}>
        The current beta includes a 30-day Pro trial with &pound;45 of calling
        credit. No pressure, no hard sell: request an invite, read the pricing,
        and see whether it feels like the right fit.
      </Typography>
    </Box>

    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
      <Link href={PARTNER.url} target="_blank" rel="noopener" underline="none" sx={{ flex: 1 }}>
        <Button size="lg" fullWidth endDecorator={<ArrowForward fontSize="xl" />}>
          Request a {PARTNER.name} invite
        </Button>
      </Link>
      <Link href={PARTNER.pricingUrl} target="_blank" rel="noopener" underline="none" sx={{ flex: 1 }}>
        <Button size="lg" fullWidth variant="outlined">
          See pricing
        </Button>
      </Link>
    </Box>

    <Typography level="body2">
      If you were here for the underlying reference material, the{' '}
      <Link href={PARTNER.apiDocsUrl} target="_blank" rel="noopener" fontWeight="lg">
        API docs remain public
      </Link>
      .
    </Typography>

    <Divider>already with us?</Divider>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography level="body2">
        Existing playground accounts are unaffected &mdash; sign in as usual,
        and password reset still works.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link fontSize="sm" href="/login" fontWeight="lg">
          Sign in
        </Link>
        <Link fontSize="sm" href="/password-reset" fontWeight="lg">
          Forgot your password?
        </Link>
      </Box>
    </Box>

  </RightImagePage>);
}
